import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
export var colorLuminance = function colorLuminance(hex) {
  var lum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');

  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  } // convert to decimal and change luminosity


  var c,
      rgb = '#';

  for (var i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }

  return rgb;
};
export var hexToRgb = function hexToRgb(hexColor) {
  var r = 0,
      g = 0,
      b = 0; // 3 digit hex color

  if (hexColor.length === 4) {
    r = '0x' + hexColor[1] + hexColor[1];
    g = '0x' + hexColor[2] + hexColor[2];
    b = '0x' + hexColor[3] + hexColor[3]; // 6 digit hex color
  } else if (hexColor.length === 7) {
    r = '0x' + hexColor[1] + hexColor[2];
    g = '0x' + hexColor[3] + hexColor[4];
    b = '0x' + hexColor[5] + hexColor[6];
  }

  return 'rgb(' + +r + ', ' + +g + ', ' + +b + ')';
};